import { VerificationCheckConfiguration } from 'dashboard/forms/FormVerificationTemplateChecks/FormVerificationTemplateChecks';
import UpdateRiskTriggerLevel from 'dashboard/forms/FormVerificationTemplateChecks/Shared/UpdateRiskTriggerLevel';
import { RiskConfigCheckConfig } from 'dashboard/models/verification-check';
import { VerificationCheckConfig } from 'dashboard/models/verification-check-config/verification-check-config';

export const HIGH_RISK_THRESHOLD_DESCRIPTION =
  'A high risk threshold will only fail High Risk submissions (Optimized for reducing false failures).';
export const LOW_RISK_THRESHOLD_DESCRIPTION =
  'A low risk threshold will fail Low, Medium and High Risk submissions (Optimized for reducing false approvals).';

interface RiskConfigConfigurationElementProps {
  checkConfig: RiskConfigCheckConfig;
  editable: boolean;
  handleUpdateCheck: (check: VerificationCheckConfig) => void;
}

const RiskConfigConfigurationElement = ({
  checkConfig,
  editable,
  handleUpdateCheck,
}: RiskConfigConfigurationElementProps) => {
  if (!checkConfig['risk-configs']) return null;
  const enabledRiskConfigs = checkConfig['risk-configs'].filter((riskConfig) => riskConfig.enabled);
  if (enabledRiskConfigs.length > 0)
    return (
      <VerificationCheckConfiguration
        title='Risk Level'
        helpText={
          <>
            <>{HIGH_RISK_THRESHOLD_DESCRIPTION}</>
            <br />
            <>{LOW_RISK_THRESHOLD_DESCRIPTION}</>
          </>
        }
        disabled={!editable}
      >
        <UpdateRiskTriggerLevel
          checkConfig={checkConfig}
          editable={editable}
          handleUpdateCheck={handleUpdateCheck}
        />
      </VerificationCheckConfiguration>
    );
};

export default RiskConfigConfigurationElement;
